import { Box } from "@material-ui/core"
import { BannerResponse } from "api"
import { useIsDesktop } from "common/MediaQueries"
import { useGroupCardContext } from "components/Balance/GroupCardContext"
import GenericButton from "components/GenericButton/GenericButton"
import { useGroupPurchasesContext } from "components/PurchasePage/GroupPurchasesContext"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import styled from "styled-components"

const StyledButtonWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 20px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    justify-content: flex-start;
    align-items: center;
    padding: 0 16px;
    margin-top: 16px;
  }
`

type MainBannerActionsProps = {
  divRef: React.RefObject<HTMLDivElement>
  banner: BannerResponse
}

const MainBannerActions = ({ divRef, banner }: MainBannerActionsProps) => {
  const isDesktop = useIsDesktop()

  const scrollTo = () => {
    if (divRef && divRef.current) {
      const yOffset = isDesktop ? -90 : -60
      const y =
        divRef.current.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset
      window.scrollTo({ top: y, behavior: "smooth" })
    }
  }

  const { setPurchaseData } = usePurchaseContext()
  const { setGroupCard } = useGroupCardContext()
  const { setGroupPurchasesData } = useGroupPurchasesContext()
  const clearGroupPurchaseContext = () => {
    setPurchaseData({})
    setGroupCard({})
    setGroupPurchasesData(null)
  }
  return (
    <StyledButtonWrapper>
      {banner.hideRightButton ? (
        <></>
      ) : banner.rightButtonLink && banner.rightButtonTitle ? (
        <GenericButton
          onClick={() =>
            banner.rightButtonLink === "/groupPurchases" &&
            clearGroupPurchaseContext()
          }
          buttonHref={banner.rightButtonLink}
          btnType="filled"
          width={188}
          mobileWidth="auto"
        >
          {banner.rightButtonTitle}
        </GenericButton>
      ) : (
        <GenericButton
          onClick={scrollTo}
          aria-label="מעבר לאזור בעמוד המכיל מידע מתאים אודות בחירת גפיטקארד מתאים"
          btnType="filled"
          width={188}
          mobileWidth="auto"
        >
          בחירת גיפטקארד
        </GenericButton>
      )}

      {banner.hideLeftButton ? (
        <></>
      ) : (
        <GenericButton
          btnType="outlined"
          width={188}
          mobileWidth="auto"
          buttonHref={
            banner.leftButtonTitle && banner.leftButtonLink
              ? banner.leftButtonLink
              : "/balance"
          }
        >
          {banner.leftButtonTitle && banner.leftButtonLink
            ? banner.leftButtonTitle
            : "היתרה שלי"}
        </GenericButton>
      )}
    </StyledButtonWrapper>
  )
}

export default MainBannerActions
